module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Virgil Alexander\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Virgil Alexander is an award-winning author who bases his writing in the American Southwest, where he has lived and worked his entire life. In addition to his five-book Deputy Allred & Apache Officer Victor series, Alexander has written about Western history for numerous magazines, newspapers, webpages, museums, and the Arizona History Convention. He was also the co-editor of "), _c('I', [_vm._v("Miami: A History of the Miami Area, Arizona")]), _vm._v(".")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/aeRBsr/tc-custom/9781504090094.jpg?1707506383328",
      "alt": "This image is the cover for the book Murder in Copper, Deputy Allred & Apache Officer Victor"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Murder in Copper, Deputy Allred & Apache Officer Victor\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("A copper theft investigation puts Arizona and the Apache Tribal Police on the trail of a deadly conspiracy in this borderland mystery thriller.")])]), _c('p', [_vm._v(" Sgt. Bren Allred has seen all manner of criminality in beautiful Graham County, Arizona. He has managed to keep the worst of it from his wife, Monica, who is having a troubled pregnancy. But it will be difficult to keep the devils at bay as a new kind of trouble erupts across the region . . . ")]), _vm._v(" When deputies Sanchez and Haley go undercover to investigate a rash of copper theft, they unwittingly stumble across a shadowy spy network. Meanwhile, Apache Police Sgt. Al Victor is confronted by a murder case involving a diplomat as he grapples with the ever-present problem of alcohol on the reservation.\n    "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0